import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=f20a5e0c&scoped=true&"
import script from "./Light.vue?vue&type=script&lang=js&"
export * from "./Light.vue?vue&type=script&lang=js&"
import style0 from "./Light.vue?vue&type=style&index=0&id=f20a5e0c&prod&scoped=true&lang=less&"
import style1 from "./Light.vue?vue&type=style&index=1&id=f20a5e0c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20a5e0c",
  null
  
)

export default component.exports